import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { DocumentUploadFormEdit } from "./document-upload-form/document-upload-form.component";
import { SupplierService } from '../../../core/services/person/supplier/supplier.service'
import { MatSpinner } from '@angular/material/progress-spinner'
import { MatProgressBar } from '@angular/material/progress-bar'



@Component({
  selector: 'document-upload-edit',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatProgressBar,
    DocumentUploadFormEdit,
    MatSpinner
],
  templateUrl: './document-upload-edit.component.html',
  styleUrl: './document-upload-edit.component.scss',
  providers: [AddressTypeService],
  standalone: true,
})
export class DocumentUploadEditComponent implements OnInit, AfterViewInit {
  constructor(
    private supplierService:SupplierService
  ) {}

  item: any = {}
  itemsList: any[] = []
  fileList: any[] = []
  contactList: any[] = []
  loading: any = false
  rows: number = 10
  page: number = 1

  @Input() idPerson: number = 0
  @Output() response: EventEmitter<any> = new EventEmitter()
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'tipoDocDescricao',
      key: 'tipoDocDescricao',
      description: 'Tipo Documento',
    },
    {
      keyColumn: 'descricao',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'nomeArquivo',
      key: 'nomeArquivo',
      description: 'Documento',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = [
    'tipoDocDescricao',
    'descricao',
    'nomeArquivo',
    'action',
  ]

  ngOnInit(): void {
    this.getItem()
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  /**
   * Atualiza a renderização da tabela e o paginador
   */
  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }

  /**
   * Busca a lista de documentos do fornecedor
   */
  getItem() {
    this.loading = true
    this.supplierService.listPagedSupplierDoc(this.idPerson, this.page, this.rows).subscribe({
      next: (res) => {
        if (!res.data || res.data.length === 0) {
          this.itemsList = []
        } else {
          this.itemsList = res.data
        }
        this.tableSource = new MatTableDataSource<any>(this.itemsList)
        this.refreshTable()
        this.loading = false
      },
      error: (err: any) => {
        console.error('Erro ao buscar documentos:', err)
        this.loading = false
      }
    })
  }

  /**
   * Trata as respostas vindas do componente de formulário (filho)
   */
  responseForm(element: any, type: string) {
    // Caso a ação venha do formulário de documentos
    if (type === 'file') {
      switch (element.action) {
        case 'create':
        case 'edit':
          this.item = null
          this.getItem()
          break

        case 'cancel':
          this.item = null
          break
      }
    }


    this.response.emit(this.itemsList)
  }

  /**
   * Seleciona um item da tabela para carregar no formulário
   */
  selectItemEvent(element: any) {

    this.item = { ...element }
  }

  /**
   * Remove um documento após confirmação
   */
  deleteItemEvent(element: any) {
    if (confirm('Tem certeza que deseja excluir este documento?')) {
      this.loading = true
      this.supplierService.deleteDocSupplier(element.id).subscribe({
        next: (res) => {
          this.getItem()
          this.loading = false
        },
        error: (err: any) => {
          console.error('Erro ao deletar:', err)
          this.loading = false
        }
      })
    }
  }

  downloadItemEvent(element: any) {
    this.loading = true;
    this.supplierService.downloadDocSupplier(element.id).subscribe({
      next: (response: any) => {
        try {
          // Decodifica o base64
          const byteCharacters = atob(response.fileContent);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);

          // Usa o tipo retornado pelo backend ou detecta pela extensão
          const mimeType = response.type || this.getMimeType(element.nomeArquivo);
          const blob = new Blob([byteArray], { type: mimeType });

          // Cria o link de download
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = response.fileName || element.nomeArquivo || 'documento';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          this.loading = false;
        } catch (error) {
          console.error('Erro ao processar o arquivo:', error);
          alert('Erro ao processar o arquivo para download');
          this.loading = false;
        }
      },
      error: (err) => {
        this.loading = false;
        console.error('Erro ao realizar download:', err);
        alert('Erro ao baixar o arquivo. Tente novamente.');
      }
    });
  }

  private getMimeType(fileName: string): string {
    const extension = fileName.split('.').pop()?.toLowerCase();
    const mimeTypes: { [key: string]: string } = {
      'pdf': 'application/pdf',
      'jpg': 'image/jpeg',
      'jpeg': 'image/jpeg',
      'png': 'image/png',
      'gif': 'image/gif',
      'doc': 'application/msword',
      'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'xls': 'application/vnd.ms-excel',
      'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'txt': 'text/plain',
      'zip': 'application/zip',
      'rar': 'application/x-rar-compressed'
    };
    return mimeTypes[extension || ''] || 'application/octet-stream';
  }
}
